import dayjs from 'dayjs';

export default function formatDate(date: string | Date, format = 'DD/MM/YYYY') {
  return dayjs(date).format(format);
}
